import { PaperBlock } from './paper-block'

export interface PaperInterface {
  /**
   * 名称
   */
  name?: string
  /**
   * 描述
   */
  description?: string
  /**
   * 测验题目数量
   */
  blockCount?: number
  /**
   * 测验题目分数
   */
  scoreSum?: string
  /**
   * 测验题目分数
   */
  originId?: number
  /**
   * 关联的块
   */
  blocks?: PaperBlock[]
  /**
   * 是否展示到列表中（被引用创建的不展示）
   */
  isShow?: number
  /**
   * 是否设置分数
   */
  showScore?: number
  /**
   * 试卷下小题数
   */
  questionCount?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string
}

export class Paper implements PaperInterface {
  /**
   * 名称
   */
  name?: string
  /**
   * 描述
   */
  description?: string
  /**
   * 测验题目数量
   */
  blockCount?: number
  /**
   * 测验题目分数
   */
  scoreSum?: string
  /**
   * 测验题目分数
   */
  originId?: number
  /**
   * 关联的块
   */
  blocks?: PaperBlock[]
  /**
   * 是否展示到列表中（被引用创建的不展示）
   */
  isShow?: number
  /**
   * 是否设置分数
   */
  showScore?: number
  /**
   * 试卷下小题数
   */
  questionCount?: number
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
  /**
   * 创建时间
   */
  createdAt: string
  /**
   * 更新时间
   */
  updatedAt: string

  constructor(props: PaperInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      description: _description,
      blockCount: _blockCount,
      scoreSum: _scoreSum,
      originId: _originId,
      blocks: _blocks,
      isShow: _isShow,
      showScore: _showScore,
      questionCount: _questionCount,
      id: _id,
      schoolId: _schoolId,
      createdAt: _createdAt,
      updatedAt: _updatedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name
    this.description = _description
    this.blockCount = _blockCount
    this.scoreSum = _scoreSum
    this.originId = _originId
    this.blocks = _blocks ? _blocks.map((i) => new PaperBlock(i)) : _blocks
    this.isShow = _isShow
    this.showScore = _showScore
    this.questionCount = _questionCount
    this.id = _id
    this.schoolId = _schoolId
    this.createdAt = _createdAt
    this.updatedAt = _updatedAt
  }
}
